import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';

interface ExchangeRateResponse {
  rate: number;
  fetched_at: string;
}

export function useFetchExchangeRate() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.get<ExchangeRateResponse>('/exchange-rates/usd-mxn');
      return data;
    },
  });
}
